import { render, staticRenderFns } from "./IdentityVerification.vue?vue&type=template&id=68a0015a&scoped=true&"
import script from "./IdentityVerification.vue?vue&type=script&lang=js&"
export * from "./IdentityVerification.vue?vue&type=script&lang=js&"
import style0 from "./IdentityVerification.vue?vue&type=style&index=0&id=68a0015a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0015a",
  null
  
)

export default component.exports